export default "__VITE_ASSET__BeI286D5__"